export const ProjectData=[
    {
        id:1,
        title:"Study, implementation and analysis of the LPN Algorithm",
        about:"Implemented three LPN algorithms using c++ and give one improvement in terms of memory.",
        tags:["C++"],
        demo: '',
        github:'https://github.com/Attull/Mtech-Project',
        image:"https://bidtellect.com/wp-content/uploads/2016/11/Content-Marketing-CIR-300x197.png"
    },
    {
        id:2,
        title:"40 Mini Javascript Projects",
        about:"Theme digital clock, Movie UI layout, sound board, Rotating & animated navigation styling and lot more",
        tags:["Javascript","HTML/CSS"],
        demo: '',
        github:'https://github.com/Attull/50projects_In_50days',
        image:"https://www.seawindsolution.com/assets/front/images/dig-mar-content-img.png"
    },
    {
        id:3,
        title:"IoT based Home automation",
        about:"Use ESP8266 chip to implement Home automation in both hindi and english language",
        tags:["esp8266","C"],
        demo: 'https://www.youtube.com/watch?v=T-yoJNpn4oA',
        github:'',
        image:"https://iotdesignpro.com/sites/default/files/main-image/IoT-Home-Automation-using-Blynk-App-and-ESP32.jpg"
    }


];